import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { listPartnerPlans } from '../services/partnerPlans';
import { partnerPlansQueryKeys } from './query-keys';

export const usePartnerPlansQuery = (options = {}) => {
  const { isPartner } = useAuth();
  const { enabled = true, ...rest } = options;

  return useQuery({
    queryKey: partnerPlansQueryKeys.all,
    enabled: isPartner && enabled,
    queryFn: async () => {
      const result = await listPartnerPlans();
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch partner subscription plans');
      }
      return result.data;
    },
    ...rest,
  });
};
